import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {SelectField} from "./FilterComponentStyles";
import {CompanyFilterPropTypes} from "./FilterComponentPropTypes";
import {useObserver} from "mobx-react-lite";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import turkishToEnglish from "../../../constants/turkishToEnglish";

const CompanyFilter = ({
    showPoolOption = true,
    showAllOption = false,
    allKey = "",
    hideTitle = false,
    includeInactives = false,
    selectMarginBottom = "20px",
    city,
    optionFilter = () => {
        return true;
    },
    cityFilter = (company, city) => {
        if (!city || city === "all") return true;
        return company?.city === city;
    },
    ...props
}: CompanyFilterPropTypes) => {
    const {t} = useTranslation();
    const stores = useStore();

    return useObserver(() => (
        <React.Fragment>
            {!hideTitle && <h5>{t("fields.company", {ns: "common"})}</h5>}
            <SelectField
                allowClear
                showSearch
                mb={selectMarginBottom}
                filterOption={(input, option) => {
                    if (!input || !option || !option.children) return false;

                    const searchInput = input.toLowerCase();
                    const englishInput = turkishToEnglish(searchInput);

                    const optionText = option.children.toLowerCase();
                    const englishOptionText = turkishToEnglish(optionText);

                    return (
                        optionText.includes(searchInput) || englishOptionText.includes(englishInput)
                    );
                }}
                data-testid="companySelect"
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value={allKey} data-testid="companySelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {props.list
                    ? props.list?.map(company => (
                          <SelectField.Option
                              key={company}
                              value={company}
                              data-testid="companySelect_option"
                          >
                              {company}
                          </SelectField.Option>
                      ))
                    : arrayAlphabeticalSort(
                          [
                              ...stores.appStore.companyListFilter.filter(company =>
                                  includeInactives ? true : !company.disabled
                              )
                          ],
                          "companyName"
                      )
                          .filter(company => optionFilter(company) && cityFilter(company, city))
                          .map(company => (
                              <SelectField.Option
                                  key={company._id}
                                  value={company._id}
                                  data-testid="companySelect_option"
                              >
                                  {company.companyName}
                              </SelectField.Option>
                          ))}
            </SelectField>
        </React.Fragment>
    ));
};

export default CompanyFilter;
